export default function ReportWorkflowTrail({ title = 'Report trail', scope, items = [], testId }) {
    return (
        <div className="rounded-lg border border-slate-200 bg-white p-4 shadow-sm" data-testid={testId}>
            <div className="flex flex-col gap-1 border-b border-slate-100 pb-3 md:flex-row md:items-center md:justify-between">
                <div>
                    <h3 className="text-sm font-semibold text-slate-900">{title}</h3>
                    <p className="text-xs text-slate-500">How to read this report and where the source work appears next.</p>
                </div>
                {scope && (
                    <span className="mt-2 inline-flex w-fit rounded-full bg-blue-50 px-3 py-1 text-xs font-semibold text-blue-700 md:mt-0">
                        {scope}
                    </span>
                )}
            </div>
            <div className="grid grid-cols-1 gap-4 pt-4 md:grid-cols-4">
                {items.map((item) => (
                    <div key={item.label} className="border-l-2 border-slate-200 pl-3">
                        <p className="text-[11px] font-semibold uppercase tracking-wide text-slate-400">{item.label}</p>
                        <p className="mt-1 text-sm leading-5 text-slate-700">{item.value}</p>
                    </div>
                ))}
            </div>
        </div>
    );
}
